import mixins from "vue-typed-mixins";
import { gtmMixin } from "@/mixins";
const ModalForgotNpsn = () => import("@/pages/home/_account-lookup/ModalForgotNpsn.vue");
const Button = () => import("@/components/Button.vue");
export default mixins(gtmMixin).extend({
    components: { ModalForgotNpsn, Button },
    data: () => ({
        isOpen: false,
    }),
    methods: {
        onClick() {
            this.isOpen = true;
            this.gtmClickLink("lupa_npsn");
        },
    },
});
